import type { ErrorCategory } from '@sentinel/shared';

export interface ApiErrorDetail {
  path: string;
  code: string;
}

/** The client-side twin of the server envelope. Never shown raw: `messageKey` is translated. */
export class ApiError extends Error {
  readonly status: number;
  readonly category: ErrorCategory;
  readonly code: string;
  readonly requestId: string | null;
  readonly details: ApiErrorDetail[];

  constructor(input: {
    status: number;
    category: ErrorCategory;
    code: string;
    requestId: string | null;
    details?: ApiErrorDetail[];
  }) {
    super(input.code);
    this.name = 'ApiError';
    this.status = input.status;
    this.category = input.category;
    this.code = input.code;
    this.requestId = input.requestId;
    this.details = input.details ?? [];
  }

  /** i18n key: a specific one per code when it exists, the category otherwise. */
  get messageKey(): string {
    return `errors.codes.${this.code}`;
  }

  get categoryKey(): string {
    return `errors.categories.${this.category}`;
  }

  static connection(): ApiError {
    return new ApiError({
      status: 0,
      category: 'connection',
      code: 'connection.unreachable',
      requestId: null,
    });
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
